import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const names = ['Camila', 'Martina', 'Sofía', 'Valentina', 'Julieta', 'Lucía', 'Florencia', 'Micaela', 'Agustina', 'Rocío', 'Facundo', 'Tomás', 'Lucas', 'Mateo', 'Nicolás'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Corrientes'];
export const PurchasePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1; // 1 to 59 minutes
      setCurrentBuyer({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 10000);
    // Interval for subsequent popups (every 20-35 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 15000) + 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-130">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-slate-200 p-3 pr-8 flex items-center gap-3 max-w-xs" data-id="element-131">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-132">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-133" />
          </div>
          <div data-id="element-134">
            <p className="text-sm text-slate-800 font-medium" data-id="element-135">
              <span className="font-bold" data-id="element-136">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-slate-500" data-id="element-137">
              Compró el Atlas del Instrumentador
            </p>
            <p className="text-[10px] text-cyan-600 font-medium mt-0.5" data-id="element-138">
              {currentBuyer.time}
            </p>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-139">
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-140">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-141" />
            </svg>
          </button>
        </motion.div>}
    </AnimatePresence>;
};